module.exports = __webpack_public_path__ + "img/1389735268.b6335ad8.jpg";